import { IconProps } from '../types'

export const Poly = ({ width = 8, height = 12 }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M-0.000187457 0.175951C-0.000187457 0.0479507 0.0638125 -4.95911e-05 0.175813 -4.95911e-05H3.83981C6.28781 -4.95911e-05 7.82381 1.15195 7.82381 3.39195C7.82381 5.72795 6.23981 6.89595 3.85581 6.89595H1.51981L1.58381 11.024C1.58381 11.152 1.51981 11.2 1.40781 11.2H0.175813C0.0638125 11.2 -0.000187457 11.152 -0.000187457 11.024L0.0798125 5.45595L-0.000187457 0.175951ZM1.50381 5.55195V5.75995H3.95181C5.37581 5.75995 6.35181 5.11995 6.35181 3.42395C6.35181 1.85595 5.45581 1.13595 3.88781 1.13595H1.56781L1.50381 5.55195Z" />
  </svg>
)
